import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  Select,
  MenuItem,
  Typography,
  Checkbox,
  DialogActions,
  Dialog,
  DialogTitle,
  FormControl,
  DialogContent,
  TextField,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import {
  useLazyDeleteTutorByIdQuery,
  useLazyGetAllTutorListingQuery,
  useLazyTutorCsvQuery,
} from "../../services/tutor";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { successToast, errorToast } from "../../helpers";
import Loader from "../../helpers/Loader";
import WarnModal from "../../components/modals/WarnModal";
import Pagination from "../../components/Pagination";
import { usePutTutorProfileMutation } from "../../services/tutor";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validation";
import { Add } from "@mui/icons-material";
import {
  useLazyGetAllPromosQuery,
  useUpdatePromoMutation,
} from "../../services/promocodes";
import { STATUS } from "../../helpers/constants/enums";

export interface PromoCode {
  id: number;
  code: string;
  discountValue: number;
  totalUsableCount: number;
  expiryDate: string;
  tutor_name: string;
  tutor_email: string;
  adminApproved: string;
  createdAt: string;
  status: boolean;
}

const Rejected = ({}: any) => {
  const [exportCsv] = useLazyTutorCsvQuery();
  const [page, setPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  const [stateofTutor, setstateofTutor] = useState<{ [key: string]: number }>(
    {}
  );
  const [deleteById] = useLazyDeleteTutorByIdQuery();
  const [updateTutorStatus] = usePutTutorProfileMutation();
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  let totalPages = Math.ceil(totalCount / 10);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const navigate = useNavigate();
  const [rows, setRows] = useState<PromoCode[]>([]);
  const [value, setValue] = useState<number>(1);
  const [tututorStatust, settututorStatust] = useState<number>(2);
  const [getAllPromo, { isLoading }] = useLazyGetAllPromosQuery();
  const [updateStatus] = useUpdatePromoMutation();
  const [selectedTutor, setSelectedTutor] = useState("");
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [addPromoCodes, setAddPromoCodes] = useState<any>();
  const [openPromo, setOpenPromo] = useState(false);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows([]);
  };

  const handleTutorChange = (event: any) => {
    setSelectedTutor(event.target.value);
  };
  const handlePromoClose = () => {
    setOpenPromo(false);
  };

  const fetchPromos = async () => {
    try {
      const response = await getAllPromo({
        page: page,
        search: debouncedSearchTerm,
        status: STATUS.REJECTED,
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response.data?.data);
        setTotalCount(response?.data?.total);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteForum = async (id: any) => {
    try {
      // const response = await deleteById({ id }).unwrap();
      // if (response?.statusCode === 200) {
      //   successToast("Fourm deleted successfully");
      //   fetchPromos();
      // }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || "");
    }
  };

  useEffect(() => {
    fetchPromos();
  }, [page, debouncedSearchTerm, value]);

  const changeStatus = async (id: any, Status: any) => {
    if (Status == "") {
      return;
    }
    try {
      const body = {
        codeStatus:
          Status == STATUS.APPROVED ? STATUS.APPROVED : STATUS.PENDING,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await updateStatus({ id, body: encryptedBody }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Promocode State updated successfully");
        fetchPromos();
      }
    } catch (error: any) {
      errorToast(error?.message);
      console.error(error);
    }
  };
  // const changeUserStatus = async (tutorId: string[], tutorStatus: string) => {
  //   try {
  //     const body = {
  //       status: tutorStatus,
  //       ids: tutorId,
  //     };
  //     const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

  //     const response = await updateTutorStatus({ encryptedBody }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Tutor State updated successfully");
  //       fetchRejectedTutor(page, debouncedSearchTerm, tututorStatust);
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //     console.error(error);
  //   }
  // };

  // const handleDeleteTutor = async (userId: any) => {
  //   try {
  //     const response = await deleteById({ userId }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Tutor deleted successfully");
  //       fetchRejectedTutor(page, searchTerm, tututorStatust);
  //     }
  //   } catch (error: any) {
  //     console.error(error);
  //     errorToast(error?.message || "");
  //   }
  // };

  // const handleExportCsv = async () => {
  //   try {
  //     const res = await exportCsv({ tutorStatus: 2 }).unwrap();

  //     const parsedRes = typeof res === "string" ? JSON.parse(res) : res;

  //     if (parsedRes && parsedRes.message && parsedRes.message.s3Location) {
  //       window.open(parsedRes.message.s3Location);
  //       successToast("Csv exported successfully");
  //     } else {
  //       errorToast("Error: s3Location not found in response");
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //   }
  // };

  // useEffect(() => {
  //   if (value === 1 && tututorStatust === 2) {
  //     fetchRejectedTutor(page, searchTerm, tututorStatust);
  //   }
  // }, [page, searchTerm, tututorStatust, value]);

  return (
    <div>
      <Loader isLoad={isLoading} />
      <Box className="cards_header">
        <SearchBar
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(val: any) => {
            if (isValidInput(val.target.value)) {
              setSearchTerm(val.target.value);
            }
          }}
        />
        {/* <Box className="search_bar">
          <FormControl sx={{ width: "100%" }}>
            <Select
              className="select_div"
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedTutor}
              inputProps={{
                "aria-label": "Without label",
              }}
              // disabled={Boolean(_id)}
              displayEmpty
              onChange={(event) => {
                handleTutorChange(event);
              }}
            >
              <MenuItem value="" disabled>
                Select Tutor
              </MenuItem>
              <MenuItem value="MALE">Dr. Brian (brian.lee@tutors.com)</MenuItem>
              <MenuItem value="FEMALE">
                Ms. Linda (linda.park@tutors.com)
              </MenuItem>
              {/* <MenuItem value="Other">Other</MenuItem> */}
        {/* </Select>
          </FormControl>
        </Box> */}
        <Box className="cards_header_right">
          {/* <Button
            className="btn btn_primary"
            variant="contained"
            style={{
              backgroundColor: "black",
              color: "#ffffff",
              // marginLeft: "10px",
            }}
            // onClick={handleReject}
          >
            Reject
          </Button> */}

          {/* <Button
            className="btn btn_primary"
            // onClick={handleExportCsv}
          >
            <FileDownloadIcon /> Export CSV
          </Button> */}

          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-promocodes/add")}
          >
            <AddIcon />
            Add Promocode
          </Button>
        </Box>
      </Box>
      <TableContainer className="table_container">
        <Box className="heading"></Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {/* <TableCell>
                <Checkbox
                  checked={selectAll}
                  // onChange={handleSelectAllClick}
                  inputProps={{ "aria-label": "select all rows" }}
                />
              </TableCell> */}
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Code</TableCell>
              <TableCell align="center">Discount</TableCell>
              {/* <TableCell align="center">Total Usable Count</TableCell> */}
              <TableCell align="center">Expiry Date</TableCell>
              <TableCell align="center">Tutor User Name</TableCell>
              <TableCell align="center">Tutor Email</TableCell>
              <TableCell align="center">Created At</TableCell>
              {/* <TableCell align="center">Admin Approved</TableCell> */}
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No Promocode found
                </TableCell>
              </TableRow>
            ) : (
              rows?.map((row: any, i: any) => (
                <TableRow key={row?.id}>
                  {/* <TableCell>
                    <Checkbox
                      checked={selectedRows.includes(String(row.id))}
                      // onChange={(event) =>
                      //   handleRowCheckboxClick(event, row._id)
                      // }
                    />
                  </TableCell> */}
                  <TableCell align="center">
                    {(page - 1) * 10 + i + 1}
                  </TableCell>
                  {/* <TableCell>
                    <figure
                      //  onClick={() =>
                      //   navigate(`/manage-tutors/details/${row._id}`, {
                      //     state: { userStatus: "PENDING" },
                      //   })
                      // }
                      className="user_img"
                    >
                      <img
                        src={
                          row?.image || "/static/images/user_placeholder.png"
                        }
                        alt=""
                      />
                    </figure>
                  </TableCell> */}
                  <TableCell>{row?.name || "-"}</TableCell>
                  <TableCell>{row?.discount || "-"}</TableCell>
                  {/* <TableCell>{row?.codes || "-"}</TableCell> */}
                  <TableCell>{row?.expiryDate?.slice(0, 10)}</TableCell>
                  <TableCell>{row?.tutor?.userName || "-"}</TableCell>
                  <TableCell>{row?.tutor?.email || "-"}</TableCell>
                  <TableCell>{row?.createdAt?.slice(0, 10)}</TableCell>
                  <TableCell align="center">
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={""}
                      onChange={(e) => {
                        changeStatus(row?._id, e.target.value);
                      }}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Rejected
                      </MenuItem>
                      <MenuItem value={STATUS.APPROVED}>Approved</MenuItem>
                      {/* <MenuItem value={STATUS.REJECTED}>Rejected</MenuItem> */}
                      {/* <MenuItem value="1">Pending</MenuItem> */}
                    </Select>
                  </TableCell>
                  {/* <TableCell>
                    <Switch
                      defaultChecked={row?.status}
                      // onChange={(e) => {
                      //   const isChecked = !e.target.checked;
                      //   fetchApi([row._id], isChecked);
                      // }}
                      size="small"
                    />
                  </TableCell> */}
                  {/* <TableCell>
                    <Switch
                      defaultChecked={row.documentVerification}
                      // onChange={(e) => {
                      //   const isChecked = e.target.checked;
                      //   fetchApiForVerify([row._id], isChecked);
                      // }}
                      size="small"
                    />
                  </TableCell> */}
                  <TableCell>
                    <Box className="table_actions">
                      <IconButton
                        onClick={() =>
                          navigate(`/manage-promocodes/details/${row._id}`)
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                      {/* <IconButton
                        onClick={() => {
                          setOpenPromo(true);
                          setSelectedId(row?.id);
                        }}
                      >
                        <Add />
                      </IconButton> */}
                      <IconButton onClick={() => navigate(`edit/${row?.id}`)}>
                        <ModeEditIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setOpen(true);
                          setSelectedId(row?.id);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}

      <Dialog
        open={openPromo}
        onClose={handlePromoClose}
        className="revert_dialog"
      >
        <DialogTitle>Add More Count</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="revert-query-input"
            label="Add More Count"
            type="text"
            fullWidth
            value={addPromoCodes}
            onChange={(e) => {
              const inputValue = e.target.value;

              // Allow empty input or numbers between 0 and 999
              if (/^\d{0,3}$/.test(inputValue)) {
                // Also ensure value does not exceed 999
                if (inputValue === "" || parseInt(inputValue, 10) <= 999) {
                  setAddPromoCodes(inputValue);
                }
              }
            }}
            inputProps={{ inputMode: "numeric" }} // improves UX on mobile
          />
        </DialogContent>

        <DialogActions>
          <Button sx={{ background: "#65a442" }} onClick={handlePromoClose}>
            Cancel
          </Button>
          <Button
            sx={{ background: "#65a442" }}
            // onClick={handleRevertQuery}
            // disabled={revertError || revertQueryInput.trim().length === 0}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => {}}
        // handleDelete={() => handleDeleteTutor(selectedId)}
        name="Tutor"
      />
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => {}}
        // handleDelete={() => handleDeleteTutor(selectedId)}
        name="Tutor"
      />
    </div>
  );
};

export default Rejected;
